import { ConfirmeValidators } from './../../../../../../../shared/directives/validators/confirme-validators';
import { calcularDv, validarDv } from './../../../../../../../shared/common/operaciones/operacion-dv';
import { Component, OnInit } from "@angular/core";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { UsuarioService } from "./usuario.service";
import { TipoIdentificacionEntry } from "src/app/shared/entrys/tipo_identificacion.entry";
import { BasicasLoVService } from "src/app/shared/services/basicas-lov.service";
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { AuthService } from "src/app/shared/services/auth.service";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { UtilService } from 'src/app/shared/services/util.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalValidarSubcategoriaComponent } from 'src/app/components/core/layouts/modal-validar-subcategoria/modal-validar-subcategoria.component';
import { ModalCambiarContrasenaAdminComponent } from '../../../../../layouts/modal-cambiar-contrasena-admin/modal-cambiar-contrasena-admin.component';
import { AlertsService } from '../../../../../../../shared/services/alerts.service';

@Component({
  selector: "app-usuario",
  templateUrl: "./usuario.component.html",
  styleUrls: ["./usuario.component.scss"],
})
export class UsuarioComponent implements OnInit {
  tipos_identificaciones: Array<TipoIdentificacionEntry>;
  dataTabla: DatoPaginadoModel;
  headerUsuario: Array<string>;
  formUsuario: FormGroup;
  selectUsuario: any;
  camarasLista: Array<CamaraComercioEntry>;
  paginaActual: number;
  adminSuper = RolesUsuario.AdministradorSuper;
  adminCC1 = RolesUsuario.AdministradorCC;
  prestador = RolesUsuario.Prestador;
  // filtros
  filtro: FormGroup;
  public isCollapsed = true;
  camaraComercio: string;
  // Selects
  tipoUsuario: Array<any> = [];
  tipoPrestador: Array<any> = [];

  formDv: FormGroup;
  codigoDv: any;
  saveDv: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private usuarioService: UsuarioService,
    private basicasLoVService: BasicasLoVService,
    private establecimientoComercioService: EstablecimientoComercioService,
    public authService: AuthService,
    private modalService: NgbModal,
    private alertService:AlertsService
  ) {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
    this.createForm();
    this.formUsuario.get("activo").disable();
    this.consultarListas();

    this.onConsultarUsuario(1);

    this.selectUsuario = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.headerUsuario = [
      "Cámara de comercio",
      "Tipo de usuario",
      "Usuario",
      "Nombre",
      "Correo electrónico",
      "Tipo ID",
      "Número identificación",
      "Digito verificacion",
      "Cargo",
      "Fecha de última atenticación",
      "Fecha de creación",
      "Estado",
      "Acción",
    ];

    this.basicasLoVService
      .getTiposIdentificacion(null)
      .subscribe((resultado) => {
        if (resultado.result) {
          this.tipos_identificaciones = resultado.data as Array<TipoIdentificacionEntry>;
        }
      });
    this.establecimientoComercioService.getCamaras().subscribe((resultado) => {
      if (resultado) {
        this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
        if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
          this.formUsuario
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
          this.camaraComercio = this.camarasLista.find(
            (x) => x.codigo_camara === this.authService.getCamaraUser()
          ).desc_camara;
        }
      }
    });


  }

  createForm() {
    this.formUsuario = this.formBuilder.group({
      usuario: [null, Validators.required],
      correo_electronico: [null, Validators.required],
      tipo_usuario_id: [null, Validators.required],
      nombres: [null, Validators.required],
      apellidos: [null],
      tipo_identificacion_id: [null, Validators.required],
      numero_identificacion: [null, Validators.required],
      cargo: [null],
      tipo_prestador_id: [null],
      clave_acceso: [null, ConfirmeValidators.passwordValidatorNulleable],
      activo: [null],
      codigo_camara: [null, [Validators.required]],
    });

    this.filtro = this.formBuilder.group({
      codigo_camara: [null],
      tipo_usuario_id: [null],
      numero_identificacion: [null],
      usuario: [null],
      // nombres: [null],
      // apellidos: [null],
      correo_electronico: [null],
      cargo: [null],
      activo: [null],
    });

    this.formDv = new FormGroup({
      numero_identificacion2: new FormControl(''),
      digito_verificacion: new FormControl(''),
    }, {
      validators: validarDv('numero_identificacion2', 'digito_verificacion')
    });

  }

  onConsultarUsuario(page: number) {
    this.usuarioService
      .get({ ...this.filtro.value, numeroPagina: page })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarUsuario(value);
  }

  onAgregarUsuario() {
    this.usuarioService
      .create({
        ...this.formUsuario.value,
        activo: 1,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.onConsultarUsuario(this.paginaActual);
          this.formUsuario.reset();
          if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
            this.formUsuario
              .get("codigo_camara")
              .patchValue(this.authService.getCamaraUser());
          }
        }
      });
  }

  onOperarUsuario() {
    if (!this.selectUsuario) {
      this.onAgregarUsuario();
    } else {
      if(this.formUsuario.get('clave_acceso').value != null && this.formUsuario.get('clave_acceso').value != ''){
        this.establecimientoComercioService
              .getParametro({
                parametro_id:"CAMBIAR_CONTRASENA_DESDE_ADMIN",
                agrupacion: "TRATAMIENTO_DE_DATOS",
                auxiliar: "1",
              })
              .subscribe((resultado2) => {
                if (resultado2.result) {
                  const modalAceptarTerminos = this.modalService.open(
                    ModalCambiarContrasenaAdminComponent,
                    { centered: true, backdrop: "static", size: "md" }
                  );
                  modalAceptarTerminos.componentInstance.mensaje =
                    resultado2.data;
                  modalAceptarTerminos.result.then(response=>{
                    this.onModificarUsuario();
                    this.alertService.success(
                      "Se actualizó la contraseña",
                      null,
                      null
                    );
                  })
                }
              });
      }else{
        this.onModificarUsuario();
      }
      
    }
  }

  onCargarUsuario(entry: any) {


    // entry.credenciales_expiradas = entry.credenciales_expiradas ? 1 : 0;
    // entry.es_super_administrador = entry.es_super_administrador ? 1 : 0;
    // entry.esta_bloqueado = entry.esta_bloqueado ? 1 : 0;
    // entry.esta_expirado = entry.esta_expirado ? 1 : 0;
    // entry.requiere_modificacion_clave_acceso = entry.requiere_modificacion_clave_acceso ? 1 : 0;
    entry.activo = entry.activo ? 1 : 0;
    this.formUsuario.patchValue({
      ...entry,
    });

    this.selectUsuario = entry;

    if (this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
      if (
        this.selectUsuario.tipo_usuario_id ===
        parseInt(RolesUsuario.Funcionario, 10) ||
        this.selectUsuario.tipo_usuario_id ===
        parseInt(RolesUsuario.Prestador, 10) ||
        this.selectUsuario.tipo_usuario_id ===
        parseInt(RolesUsuario.SoloConsulta, 10)
      ) {
        //this.formUsuario.get("usuario").disable();
        this.formUsuario.get("tipo_usuario_id").disable();
        this.formUsuario.get("nombres").disable();
        this.formUsuario.get("apellidos").disable();
        //this.formUsuario.get("tipo_identificacion_id").disable();
        //this.formUsuario.get("numero_identificacion").disable();
        //this.formUsuario.get("codigo_camara").disable();
        this.formUsuario.get("activo").enable();
        // this.formUsuario.get('cargo').disable();
        if (
          !(
            this.selectUsuario.tipo_usuario_id === parseInt(RolesUsuario.Prestador, 10) ||
            this.selectUsuario.tipo_usuario_id === parseInt(RolesUsuario.Funcionario, 10) ||
            this.selectUsuario.tipo_usuario_id === parseInt(RolesUsuario.SoloConsulta, 10)
          )
        ) {
          this.formUsuario.get("cargo").disable();
          if (this.formUsuario.get("tipo_prestador_id").validator?.length > 0) this.formUsuario.get("tipo_prestador_id").clearValidators();
        } else {
          this.formUsuario.get("tipo_prestador_id").setValidators([Validators.required]);
        }
      } else {
        this.formUsuario.enable();
        this.formUsuario.get("tipo_usuario_id").disable();
        //this.formUsuario.get("codigo_camara").disable();
        this.formUsuario.get("activo").enable();
      }
    } else {
      if (
        this.selectUsuario.tipo_usuario_id ===
        parseInt(RolesUsuario.AdministradorCC, 10) ||
        this.selectUsuario.tipo_usuario_id ===
        parseInt(RolesUsuario.Prestador, 10) ||
        this.selectUsuario.tipo_usuario_id ===
        parseInt(RolesUsuario.Depositario, 10)
      ) {
        this.formUsuario.get("usuario").disable();
        this.formUsuario.get("tipo_usuario_id").disable();
        this.formUsuario.get("nombres").disable();
        this.formUsuario.get("apellidos").disable();
        this.formUsuario.get("tipo_identificacion_id").disable();
        this.formUsuario.get("numero_identificacion").disable();
        // this.formUsuario.get("cargo").disable();
        if (
          !(
            this.selectUsuario.tipo_usuario_id === parseInt(RolesUsuario.Prestador, 10) ||
            this.selectUsuario.tipo_usuario_id === parseInt(RolesUsuario.AdministradorCC, 10)
          )
        ) {
          if (this.selectUsuario.tipo_usuario_id !== parseInt(RolesUsuario.Depositario, 10)) this.formUsuario.get("cargo").disable();
          if (this.formUsuario.get("tipo_prestador_id").validator?.length > 0) this.formUsuario.get("tipo_prestador_id").clearValidators();
        } else {
          this.formUsuario.get("tipo_prestador_id").setValidators([Validators.required]);
        }
        this.formUsuario.get("codigo_camara").disable();
        this.formUsuario.get("activo").enable();
      } else {
        this.formUsuario.enable();
        this.formUsuario.get("tipo_usuario_id").disable();
        this.formUsuario.get("codigo_camara").disable();
        this.formUsuario.get("activo").enable();
      }
    }

    if (this.selectUsuario.tipo_usuario_id === parseInt(RolesUsuario.Prestador, 10)) {
      this.formDv.get('digito_verificacion').enable();
      this.formDv.get('digito_verificacion').setValidators([Validators.required,Validators.maxLength(1),Validators.pattern('^[0-9]*$')]);
      var num = this.formUsuario.get('numero_identificacion').value;


      this.formDv.patchValue({
        numero_identificacion2: num,//entry.numero_identificacion,
        digito_verificacion: entry.digito_verificacion
      });

    } else {
      this.formDv.get('digito_verificacion').reset();
      this.formDv.get('digito_verificacion').disable();
      this.formDv.get('digito_verificacion').clearValidators();
    }

  }

  onEliminarUsuario(entry: any) {
    this.usuarioService.delete(entry).subscribe((resultado) => {
      if (resultado.result) {
        const index = this.dataTabla.items
          .map(function (e) {
            return e.usuario_id;
          })
          .indexOf(entry.usuario_id);
        this.dataTabla.items.splice(index, 1);
        this.selectUsuario = null;
        this.formUsuario.reset();
      }
    });
  }

  onModificarUsuario() {
    this.usuarioService
      .update({
        ...this.formUsuario.value,
        clave_acceso: (this.formUsuario.get('clave_acceso').value != null)
                    ? UtilService.encrypt(this.formUsuario.get('clave_acceso').value)
                    :null,
        usuario_id: this.selectUsuario.usuario_id,
        tipo_usuario_id: this.formUsuario.value.tipo_usuario_id || this.selectUsuario.tipo_usuario_id,
        usuario: this.formUsuario.value.usuario || this.selectUsuario.usuario,
        codigo_camara: this.formUsuario.get('codigo_camara').value,
        digito_verificacion: this.formDv.get('digito_verificacion').value,
        tipo_identificacion_id: this.formUsuario.get("tipo_identificacion_id").value,
        numero_identificacion: this.formUsuario.get('numero_identificacion').value
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.onConsultarUsuario(this.paginaActual);
          this.formUsuario.reset();
          this.formUsuario.enable();
          this.formUsuario.get("activo").disable();
          this.selectUsuario = null;
          if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
            this.formUsuario.get("codigo_camara").patchValue(this.authService.getCamaraUser());
          }
        }
      });
  }
  onRestablecerContrasena() { }
  consultarListas() {
    this.usuarioService.getTipoUsuario().subscribe((resultado) => {
      if (resultado.data) {
        this.tipoUsuario = resultado.data;
      }
    });

    this.usuarioService.getTipoPrestador().subscribe((resultado) => {
      if (resultado.data) {
        this.tipoPrestador = resultado.data;
      }
    });
  }

  filtrar() {
    this.paginaActual = 1;
    this.onConsultarUsuario(1);
  }

  limpiar() {
    this.filtro.reset();
    this.filtrar();
  }

  limpiarUsuario() {
    this.onConsultarUsuario(this.paginaActual);
    if (this.formUsuario.get("tipo_prestador_id").validator?.length > 0) this.formUsuario.get("tipo_prestador_id").clearValidators();
    this.formUsuario.reset();
    this.formUsuario.enable();
    this.selectUsuario = null;
    if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
      this.formUsuario
        .get("codigo_camara")
        .patchValue(this.authService.getCamaraUser());
    }
    this.formUsuario.get("activo").disable();
  }

  get isPrestadorSeleccionado() {
    return this.selectUsuario?.tipo_usuario_id === parseInt(RolesUsuario.Prestador, 10);
  }

  onclickCalcularDV() {
    if (this.formUsuario.get('numero_identificacion').value) {
      var num = this.formUsuario.get('numero_identificacion').value;
      this.codigoDv = calcularDv(num.trim());
      this.formDv.patchValue({ digito_verificacion: this.codigoDv });
    }
  }

  onChangeVal() {
    if (this.selectUsuario.tipo_usuario_id === parseInt(RolesUsuario.Prestador, 10)) {

        if (!this.formDv.valid) {
          this.saveDv = false;
        } else {
          this.saveDv = true;
        }

    } else {
      this.saveDv = true;
    }
  }
}
